import React, { memo } from 'react'
import projectListItemConnector from 'root/src/client/logic/project/connectors/projectListItemConnector'
import withModuleContext from 'root/src/client/util/withModuleContext'
import classNames from 'classnames'
import stringFormat from 'string-format'
import SubHeader from 'root/src/client/web/typography/SubHeader'
import head from 'ramda/src/head'
import prop from 'ramda/src/prop'
import playIcon from 'root/src/client/public/icons/ic-play.svg'
import { ltGtMediaQuery } from 'root/src/client/web/commonStyles'
import unescapeHtml from 'root/src/shared/util/unescapeHtml'
import Link from 'root/src/client/web/base/Link'

const styles = {
	root: {
		marginBottom: 20,
		[ltGtMediaQuery]: {
			marginRight: 16,
		},
		cursor: 'pointer',
	},
	subHeader: {
		margin: [[8, 0, 4, 0]],
		fontSize: 14,
		fontWeight: 100,
	},
	fontStyle: {
		width: 225,
		fontSize: 14,
		fontWeight: 100,
		'@media(max-width: 1280px)': {
			width: 200,
		},
		[ltGtMediaQuery]:
		{
			width: 284,
		},
	},
	image: {
		width: '100%',
	},
	imagesContainer: {
		position: 'relative',
		overflow: 'hidden',
		borderRadius: 4,
		width: 225,
		maxHeight: 145,
		'@media(max-width: 1280px)': {
			width: 200,
			maxHeight: 130,
		},
		[ltGtMediaQuery]:
		{
			maxHeight: 162,
			width: 284,
		},
	},
	playIcon: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
}

export const SidebarItemUnconnected = memo(({
	classes, projectTitle, projectGames, projectUrl, projectDeliveries, listRouteId,
}) => (
	<Link routeId={listRouteId} routeParams={{ recordId: projectUrl }}>
		<div className={classNames('flex', classes.root)}>
			<div
				className={classes.imagesContainer}
			>
				<img
					src={
						stringFormat(
							prop('thumbnail', projectDeliveries)
					|| prop('boxArtTemplateUrl', head(projectGames)),
						)
					}
					alt={prop('name', head(projectGames))}
					className={classes.image}
				/>
				<img
					src={playIcon.src}
					alt="play"
					className={classes.playIcon}
				/>
			</div>
			<div className={classNames('flex-grow', classes.subHeader)}>
				<SubHeader className={classNames(classes.fontStyle)}>
					{unescapeHtml(projectTitle)}
				</SubHeader>
			</div>
		</div>
	</Link>
))

export default withModuleContext(
	projectListItemConnector(SidebarItemUnconnected, styles, 'MuiSidebarItem'),
)
